import type { EditorReadyOptions } from '@wix/editor-platform-sdk-types'
import { EditorSubType, EditorType } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export enum EDITOR_TYPE {
  RESPONSIVE = EditorType.Responsive,
  CLASSIC = EditorType.Classic,
  BLOCKS = EditorType.Blocks,
  STUDIO = EditorSubType.Studio,
  EDITOR3 = EditorSubType.Editor3,
}

export const resolveEditorType = ({
  editorEnv,
  editorSdkProxy,
}: {
  editorEnv: EditorReadyOptions
  editorSdkProxy: EditorSDK
}): EDITOR_TYPE => {
  const { type, subType } = editorEnv.origin
  if (editorSdkProxy.appBuilder) {
    return EDITOR_TYPE.BLOCKS
  }
  if (type === EditorType.Responsive && subType === EditorSubType.Studio) {
    return EDITOR_TYPE.STUDIO
  }
  if (type === EditorType.Responsive && subType === EditorSubType.Editor3) {
    return EDITOR_TYPE.EDITOR3
  }
  if (type === EditorType.Responsive) {
    return EDITOR_TYPE.RESPONSIVE
  }

  return EDITOR_TYPE.CLASSIC
}

export const isClassicEditor = (editorType: EDITOR_TYPE) =>
  editorType === EDITOR_TYPE.CLASSIC

export const isStudio = (editorType: EDITOR_TYPE) =>
  editorType === EDITOR_TYPE.STUDIO

export const isBlocks = (editorType: EDITOR_TYPE) =>
  editorType === EDITOR_TYPE.BLOCKS

export const isEditor3 = (editorType: EDITOR_TYPE) =>
  editorType === EDITOR_TYPE.EDITOR3
